import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationAddResourcesSyncArgs,
  BackendPerformanceCenterCustomerResource,
} from 'src/types/backend';

import { FRAGMENT_CUSTOMER_RESOURCE } from './schema';

const MUTATION = gql`
  mutation AddResourcesSync(
    $customerId: ID!
    $workspaceId: ID!
    $resources: [PerformanceCenterCustomerResourceInputType!]!
  ) {
    addResourcesSync(customerId: $customerId, workspaceId: $workspaceId, resources: $resources) {
      ...PerformanceCenterCustomerResource
    }
  }
  ${FRAGMENT_CUSTOMER_RESOURCE}
`;

type Variables = BackendMutationAddResourcesSyncArgs;
type Result = BackendPerformanceCenterCustomerResource[];

export const createResourcesSync = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
